import { css } from 'styled-components';
export default css `
  text-rendering: initial;
  color: inherit;
  margin-top: 0;
  font-weight: 700;
  ${(props) => props.variation === 'regular' &&
    css `
      font-weight: normal;
    `}
`;
